import { Dialog } from '@/components/ui/dialog';
import { Popover } from '@/components/ui/popover';

import type { ReactNode } from 'react';

export function DateRangePicker({
  mobile,
  open,
  onOpenChange,
  trigger,
  children,
}: {
  mobile: boolean;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  trigger: ReactNode;
  children: ReactNode;
}) {
  if (mobile)
    return (
      <Dialog.Root open={open} onOpenChange={onOpenChange}>
        <Dialog.Trigger asChild>{trigger}</Dialog.Trigger>
        <Dialog.Content
          className="bottom-0 top-auto w-full max-w-[410px] translate-y-0 rounded-b-none p-[16px]"
          aria-describedby={undefined}
        >
          <Dialog.Title>When</Dialog.Title>
          {children}
        </Dialog.Content>
      </Dialog.Root>
    );
  return (
    <Popover.Root open={open} onOpenChange={onOpenChange}>
      <Popover.Trigger asChild>{trigger}</Popover.Trigger>
      <Popover.Content align="start" className="w-auto p-2">
        {children}
      </Popover.Content>
    </Popover.Root>
  );
}
